module.exports = __webpack_public_path__ + "static/media/PR_55_06.c1a63bdf.jpg";